import { t } from "@/i18n-js/instance";
import { usePaywallGroupApi } from "@/react/components/PaywallGroups/Admin/hooks/usePaywallGroupApi";
import { Form } from "@/react/components/shared/uikit/Form";
import { FormTextSelect } from "@/react/components/shared/uikit/Form/FormTextSelect";
import { Typography } from "@/react/components/shared/uikit/Typography";
import type { PaywallGroupProps } from "@/react/types/PaywallGroup";
import { Loader } from "@circle-react-uikit/Loader";

const i18nBase = "settings.access_groups.paywall_migration.modal.form";

export const SubscriptionGroupChooser = ({
  currencyId,
}: {
  currencyId: number;
}) => {
  const { useListPaywallGroups } = usePaywallGroupApi({});
  const { data: paywallGroups = [], isLoading } = useListPaywallGroups({
    for_access_groups: true,
  });

  if (isLoading) {
    return <Loader />;
  }

  const eligiblePaywallGroups = (paywallGroups || []).filter(
    (group: PaywallGroupProps) => group.currency?.id === currencyId,
  );

  const options = eligiblePaywallGroups.map((group: PaywallGroupProps) => ({
    value: `${group.id}`,
    label: group.name,
  }));

  return (
    <>
      <div className="mb-2">
        <Typography.LabelMd weight="bold">
          {t([i18nBase, "subscription_groups.title"])}
        </Typography.LabelMd>
      </div>
      <div className="mt-4">
        {options.length > 0 ? (
          <>
            <Typography.BodyMd>
              {t([i18nBase, "subscription_groups.select_description"])}
            </Typography.BodyMd>
            <div className="mt-2">
              <FormTextSelect
                name="paywall_group_id"
                label={
                  <Typography.LabelSm weight="semibold">
                    {t([i18nBase, "subscription_groups.select_label"])}
                  </Typography.LabelSm>
                }
                labelClassName="!mb-2 !text-sm"
                rules={{
                  required: t([
                    i18nBase,
                    "validations.subscription_group_required",
                  ]),
                }}
                options={options}
                onChange={() => {}}
              />
            </div>
          </>
        ) : (
          <>
            <Typography.BodyMd>
              {t([i18nBase, "subscription_groups.new_description"])}
            </Typography.BodyMd>
            <div className="mx-1 mt-0.5">
              <Form.Item
                name="paywall_group_name"
                translationRoot={i18nBase}
                hideDescription
                hidePlaceholder
                hideBorder
                rules={{
                  required: t([
                    i18nBase,
                    "validations.subscription_group_required",
                  ]),
                  maxLength: {
                    value: 65,
                    message: t([
                      i18nBase,
                      "validations.subscription_group_name_max_length",
                    ]),
                  },
                }}
              >
                <Form.Input />
              </Form.Item>
            </div>
          </>
        )}
      </div>
    </>
  );
};
